/**
 * Default branding values — render-blocking fallback when Firestore
 * branding doc hasn't loaded yet (cold start, no auth, no IndexedDB cache).
 *
 * Snapshot of production schools/school_BAU_vienna_2025.branding from
 * 2026-04-28. Used to eliminate the multi-second flicker between page
 * load and Firestore branding fetch — frontend renders с правилните
 * цветове + лого from frame 1.
 *
 * IMPORTANT: ако училището смени brand identity (logo / colors / name) →
 * обнови този файл и redeploy. Ако стойностите се различават от Firestore
 * doc, useBranding ще ре-render с актуалните от Firestore (smooth switch),
 * така че rastale defaults са самоoperational concern (slightly stale flash
 * на първо зареждане), не correctness issue.
 */

import type { SchoolBranding } from '@shared/types';

export interface DefaultBrandingShape {
  branding: SchoolBranding;
  schoolName: string;
  schoolNameLocalized: Record<string, string>;
}

export const DEFAULT_BRANDING: DefaultBrandingShape = {
  branding: {
    primaryColor: '#006328',
    secondaryColor: '#f91010',
    // Bundled от frontend/public/ — same-origin, no extra DNS/TLS hop към
    // Firebase Storage; image идва веднага след initial HTML. Smooth-replace
    // от Firestore branding.logoUrl ако admin качи нова версия.
    logoUrl: '/default-logo.png',
    logoLightUrl: '/default-logo-light.png',
  },
  schoolName:
    'Българо-австрийско училище "Св. св. Кирил и Методий" - Виена',
  schoolNameLocalized: {
    bg: 'Българо-австрийско училище "Св. св. Кирил и Методий" - Виена',
    en: 'Bulgarian-Austrian School "Ss. Cyril and Methodius" - Vienna',
    de: 'Bulgarisch-österreichische Schule "Hl. Kyrill und Method" - Wien',
  },
};
